const getBrowserInfo = () => {
  const ua = navigator.userAgent
  let name = 'Unknown'
  let version = 'Unknown'

  if (/Edg\//.test(ua)) {
    name = 'Edge'
    version = ua.match(/Edg\/([\d\.]+)/)?.[1] || version
  } else if (/OPR\//.test(ua)) {
    name = 'Opera'
    version = ua.match(/OPR\/([\d\.]+)/)?.[1] || version
  } else if (/Chrome\//.test(ua)) {
    name = 'Chrome'
    version = ua.match(/Chrome\/([\d\.]+)/)?.[1] || version
  } else if (/Safari\//.test(ua)) {
    name = 'Safari'
    version = ua.match(/Version\/([\d\.]+)/)?.[1] || version
  } else if (/Firefox\//.test(ua)) {
    name = 'Firefox'
    version = ua.match(/Firefox\/([\d\.]+)/)?.[1] || version
  } else if (/MSIE |Trident\//.test(ua)) {
    name = 'Internet Explorer'
    version = ua.match(/(MSIE |rv:)([\d\.]+)/)?.[2] || version
  }

  return {
    name,
    version,
    language: navigator.language,
  }
}

export const getCommonEventData = () => {
  try {
    // Browser data
    const browserData = getBrowserInfo()

    // Screen data
    const screenData = {
      width: window.screen.width,
      height: window.screen.height,
    }

    // Referrer and UTM data
    const referrer = document.referrer
    const utmSource = new URLSearchParams(window.location.search).get('utm_source')

    return {
      browser: browserData,
      screen: screenData,
      referrer,
      utm_source: utmSource,
      environment: process.env.NODE_ENV,
      timestamp: new Date().toISOString(),
      eventId: crypto.randomUUID(),
    }
  } catch (error) {
    console.error('Error getting common event data:', error)
    return {
      timestamp: new Date().toISOString(),
      environment: process.env.NODE_ENV,
    }
  }
}
